import React from "react";
import { useLocation } from "react-router-dom";
import ProjectManagerDashboardHeader from "./dashboard";
import { EditGoodsInHeader } from "../headers/editGoodsIn";
import GoodsInHeader from "./goodsInHeader";
import { ProjectManagerSearchHeader } from "./searchHeader";
import { EditDispatchHeader } from "../headers/editDispatch";

function ProjectManagerHeader({ RightSidebarOpenCloseFlag }) {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const Location = useLocation();

  if (Location.pathname == "/app/dashboard") {
    return <ProjectManagerDashboardHeader RightSidebarOpenCloseFlag={RightSidebarOpenCloseFlag} />;
  } else if (Location.pathname.includes("/app/goodsin/detail")) {
    return <EditGoodsInHeader />
  }
  else if (Location.pathname == "/app/goodsin/list" || Location.pathname == "/app/dispatchorders/list" || Location.pathname == "/app/reports/list" || Location.pathname == "/app/report/list" || Location.pathname == "/app/iteminventoryreport/list") {
    return <GoodsInHeader />;
  } else if (Location.pathname == "/app/searchgoods/list") {
    return <ProjectManagerSearchHeader />;
  } else if (Location.pathname.includes("/app/dispatchorders/detail")) {
    return <EditDispatchHeader />
  }
  else {
    return <ProjectManagerDashboardHeader />;
  }

}

export default ProjectManagerHeader;
